import { attempt } from './attempt';
export function getWidth(node) {
    return attempt(function () { return node.getBoundingClientRect().width; }, 0);
}
